import React from 'react'

const PaymentVerification = () => {
  return (
    <div>PaymentVerification</div>
  )
}

export default PaymentVerification